import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { TransformCTA } from '../TransformCTA';
import { faqs } from '../../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-navy-50/60 px-4 py-14 sm:py-20" data-id="element-143" data-mp="2z2fft7vhl0m1">
      <div className="mx-auto w-full max-w-3xl" data-id="element-144" data-mp="3mst8n0lwb3ho">
        <h2 className="text-center font-display text-[26px] font-black leading-tight tracking-tight text-navy-950 sm:text-4xl" data-id="element-145" data-mp="3mu4d72n60f9u">
          Preguntas Frecuentes
        </h2>

        <ul className="mt-9 space-y-3" data-id="element-146" data-mp="3d3jihqam3uw7">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className="overflow-hidden rounded-2xl border border-navy-100 bg-white" data-id="element-147" data-mp="3i09thz7k80ar" data-mpi={index}>
                <h3 data-id="element-148" data-mp="ed9n6nrgupd6">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-3 px-4 py-4 text-left sm:px-6" data-id="element-149" data-mp="eekn2chsjcz0">
                    <span className="text-[15px] font-bold leading-snug text-navy-950 sm:text-lg" data-id="element-150" data-mp="2ai2xrvvosesz">
                      {faq.question}
                    </span>
                    <ChevronDownIcon className={`mt-0.5 h-5 w-5 shrink-0 text-accent transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-151" data-mp="2jgoncazksu39" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-152" data-mp="2ohm3ki10ze24">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-153" data-mp="z2eaf3eitdrn">
                      <p className="px-4 pb-4 text-[14px] leading-relaxed text-navy-800/80 sm:px-6 sm:pb-6 sm:text-base" data-id="element-154" data-mp="1nttzludelw6d">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <TransformCTA headline="Sin dudas pendientes: empieza hoy con la garantía de 7 días de tu lado." data-id="element-155" data-mp="26qd2i1xm6nuh" />
      </div>
    </section>;
}